import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectTestDay } from '../actions/selectedTestDay';
var DateSimulation = /*#__PURE__*/function (_Component) {
  function DateSimulation(props) {
    var _this;
    _classCallCheck(this, DateSimulation);
    _this = _callSuper(this, DateSimulation, [props]);
    _this.state = {
      visible: false
    };
    _this.handleSelectDay = _this.handleSelectDay.bind(_this);
    return _this;
  }
  _inherits(DateSimulation, _Component);
  return _createClass(DateSimulation, [{
    key: "handleSelectDay",
    value: function handleSelectDay(day) {
      var _this$props = this.props,
        dispatch = _this$props.dispatch,
        selectedTestDay = _this$props.selectedTestDay;
      if (day.target.value === selectedTestDay) {
        return;
      }
      dispatch(selectTestDay(day.target.value));
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var selectedTestDay = this.props.selectedTestDay;
      var visible = this.state.visible;
      var options = eventIntros.map(function (day) {
        var label = new Intl.DateTimeFormat('en-US', {
          weekday: 'long',
          month: 'long',
          day: '2-digit',
          timeZone: 'UTC'
        }).format(new Date(day));
        return /*#__PURE__*/React.createElement("option", {
          key: "option-".concat(day),
          value: day
        }, label);
      });
      var toggleLabel = visible ? 'close' : 'Simulate today\'s date';
      if (selectedTestDay) {
        toggleLabel = "today: ".concat(new Intl.DateTimeFormat('en-US', {
          weekday: 'long',
          month: 'long',
          day: '2-digit',
          timeZone: 'UTC'
        }).format(new Date(selectedTestDay)));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "sim-wrapper".concat(visible ? ' visible' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "sim-container"
      }, /*#__PURE__*/React.createElement("p", null, "Choose a day to simulate the current day of the week. Click around to see what the event days will look like before and during that day."), /*#__PURE__*/React.createElement("p", {
        className: "sim-sub"
      }, /*#__PURE__*/React.createElement("sub", null, "*This only shows when you're logged in as admin")), /*#__PURE__*/React.createElement("select", {
        value: selectedTestDay || 1,
        onChange: function onChange(value) {
          return _this2.handleSelectDay(value);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: 1,
        disabled: true
      }, "Select day to test"), options)), /*#__PURE__*/React.createElement("div", {
        className: "sim-toggle",
        onClick: function onClick() {
          return _this2.setState({
            visible: !visible
          });
        }
      }, /*#__PURE__*/React.createElement("span", null, toggleLabel)));
    }
  }]);
}(Component);
DateSimulation.propTypes = {};
export default connect(function (state) {
  return {
    selectedTestDay: state.selectedTestDay
  };
})(DateSimulation);